module.exports = __webpack_public_path__ + "static/img/round5.f9b975a9.jpg";